module.exports = __webpack_public_path__ + "img/mainImg.dba731e6.png";